export enum PromoType {
  'RI' = 'ri',
  'LV' = 'lv',
  'Carte' = 'carte',
  'Autre' = 'autre',
  'gratuité' = 'gratuité'
}
